<template>
  <div class="view-community">
    <community-shell
      :community-id="$route.params.id"
      active="feed"
      :search="search"
      @search="search = $event"
    >
      <post-composer
        v-if="canModerate"
        :community-id="$route.params.id"
        :can-moderate="canModerate"
        class="mb-3"
        @created="onPostCreated"
      />
      <community-feed
        ref="feed"
        :community-id="$route.params.id"
        :can-moderate="canModerate"
        :search="search"
      />
    </community-shell>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommunityShell from "@/components/community/CommunityShell.vue";
import PostComposer from "@/components/community/PostComposer.vue";
import CommunityFeed from "@/components/community/CommunityFeed.vue";

export default {
  name: "CommunityView",
  components: { CommunityShell, PostComposer, CommunityFeed },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    ...mapState("community", ["community"]),
    canModerate() {
      return !!(
        this.community &&
        this.community.id === this.$route.params.id &&
        this.community.can_moderate
      );
    }
  },
  methods: {
    onPostCreated() {
      if (this.$refs.feed) this.$refs.feed.reload();
    }
  }
};
</script>
